import { mapCollection } from '../../utils/collection.utils';
import { Poll } from '../poll';
import { LanguageBuilder } from './language.builder';

export class PollBuilder {
  static fromJson(json) {
    return (json)
      ? new Poll(
        json.hash,
        json.name,
        json.pollCompleteName,
        json.status,
        json.level,
        json.levelHash,
        json.startDate,
        json.endDate,
        json.version,
        json.startDaysNotification,
        json.endDaysNotification,
        json.objective,
        json.pollType,
        json.answersCount,
        json.url,
        LanguageBuilder.fromList(json.languages),
        json.logoUrl,
        json.publicName,
        json.companyName,
        json.expectedCompletionTime
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(PollBuilder.fromJson, list) : [];
  }
}
